import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import ImageUploading, { ImageListType } from "react-images-uploading";
import { defaultLogo, expandNavBar } from "../../../../utils/constants";
import NavigationTabProperties from "./navigationTabProperties";
import { SketchPicker } from "react-color";
import { IoColorPalette } from "react-icons/io5";
import { BiImageAdd } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import Switch from "react-switch";
import { Tooltip } from "react-tippy";
import "../elementProprtiesPanal.scss"


export interface NavigationPropertiesProps {
    element: Element;
  }

const NavigationProperties:FC<NavigationPropertiesProps>= ({element,})=>{
  const dispatch = useDispatch();
  const [colorPicker, setColorPicker] = useState(false);
  const [images, setImages] = React.useState([]);
  const maxNumber = 1;
  const removeImg = ()=>{
    const newElement = produce(element, draft => { draft.properties.brandLogo = ""})
    dispatch(startEditElement(newElement));
  }
  const onChange = (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined
  ) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList as never[]);
    const newElement = produce(element, draft => { draft.properties.brandLogo = imageList[0].data_url})
    dispatch(startEditElement(newElement));
  };

    return(
      <div className="container mt-3">
        <div className="form-group row">
          <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
            Name
          </label>
          <div className="col-sm-8">
            <input
              value={`${element.name}`}
              className="form-control theam-textbox"
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.name = e.target.value})
                dispatch(startEditElement(newElement));
              }}
              type="text"
              id="elementName"
            />
          </div>
        </div>
          <div className="form-group row">
            <label htmlFor="expand-nav" className="col-sm-4 col-form-label font-size-12 align-text-left">
              Expand
            </label>
            <div className="col-sm-8">
              <select
                value={element.properties.expand}
                id="expand-nav"
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newElement = produce(element, draft => { draft.properties.expand = e.target.value})
                  dispatch(startEditElement(newElement));
                }}
                >
                  {
                    expandNavBar.map((item, i) => {
                      return (
                        <option key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    })
                  }
              </select>
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="img-alt" className="col-sm-4 col-form-label font-size-12 align-text-left">
              Logo ALT
            </label>
            <div className="col-sm-8">
              <input
                value={element.properties.brandLogoAlt}
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newElement = produce(element, draft => { draft.properties.brandLogoAlt = e.target.value})
                  dispatch(startEditElement(newElement));
                }}
                type="text"
                id="img-alt"
              />
            </div>
          </div>
          <ImageUploading
            // multiple
            value={images}
            onChange={onChange}
            // maxNumber={maxNumber}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              <div className="upload__image-wrapper">
                  <div className="form-group row">
                    <div className="col">
                      <Tooltip title="Add Image" position="bottom">
                        <button className="btn btn-blue ml-3 font-size-12" style={isDragging ? { color: 'red' } :undefined} onClick={onImageUpload}  {...dragProps}><BiImageAdd size={25}/> </button>
                      </Tooltip>
                    </div>
                    <div className="col">
                    <Tooltip title="Remove Image" position="bottom">
                      <button className="btn btn-orrange ml-2 font-size-12" onClick={removeImg}><MdDelete size={25} /></button>
                      </Tooltip>
                    </div>
                  </div>
                &nbsp;
                <div key={element.properties.id} className="image-item">
                    <img src={element.properties.brandLogo} alt="" width="100" />
                </div>
              </div>
            )}
          </ImageUploading>
          <div className="form-group row">
          <label htmlFor="Link" className="col-sm-4 col-form-label font-size-12 align-text-left">
            Logo Link
          </label> 
          <div className="col-sm-8">
            <textarea
              placeholder="Image Link"
              value={`${element.properties.brandLogo}`}
              className="form-control theam-textbox"
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.properties.brandLogo = e.target.value})
                dispatch(startEditElement(newElement));
              }}
              cols={30} rows={5}
              id="Link"
            ></textarea>
          </div>
        </div>
          <div className="form-group row">
            <label htmlFor="brand-logo-size" className="col-sm-4 col-form-label font-size-12 align-text-left">
              Logo Size
            </label>
              <div className="col-sm-8">
                <input
                  value={element.properties.brandLogoSize}
                  className="form-control theam-textbox"
                  onChange={(e) => {
                    const newElement = produce(element, draft => { draft.properties.brandLogoSize =   e.target.value})
                    dispatch(startEditElement(newElement));
                  }}
                  type="number"
                  id="brand-logo-size"
                />
              </div>
          </div>
          <div className="form-group row">
            <label htmlFor="brand-name" className="col-sm-4 col-form-label font-size-12 align-text-left">
              Brand Name
            </label>
              <div className="col-sm-8">
                <input
                  value={element.properties.brandName}
                  className="form-control theam-textbox"
                  onChange={(e) => {
                    const newElement = produce(element, draft => { draft.properties.brandName = e.target.value})
                    dispatch(startEditElement(newElement));
                  }}
                  type="text"
                  id="brand-name"
                />
            </div>
          </div>
          <div className="form-group row">
          <label htmlFor="gap" className="col-sm-4 col-form-label font-size-12 align-text-left">
            Gap
          </label>
          <div className="col-sm-8">
            <input
              placeholder="Gap Between Brand Logo and Name"
              value={`${element.properties.gapBetweenLogo}`}
              className="form-control theam-textbox"
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.properties.gapBetweenLogo = e.target.value})
                dispatch(startEditElement(newElement));
              }}
              type="text"
              id="gap"
            />
          </div>
        </div>
          <div className="form-group row">
              <label htmlFor="nav-align-tab" className="col-sm-4 col-form-label font-size-12 align-text-left">
                Theme
              </label>
              <div className="col-sm-8">
                <select
                  value={element.properties.bg}
                  id="nav-align-tab"
                  className="form-control theam-textbox"
                  onChange={(e) => {
                    const newElement = produce(element, draft => { draft.properties.bg = e.target.value})
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <option key="0" value="">--select--</option>
                  <option key="1" className="bg-dark text-white" value="dark">Dark</option>
                  <option key="2" className="bg-light text-dark" value="light">Light</option>
                  <option key="3" className="bg-primary text-white" value="primary">Primary</option>
                  <option key="4" className="bg-secondary text-white" value="secondary">Secondary</option>
                  <option key="5" className="bg-success text-white" value="success">Success</option>
                  <option key="6" className="bg-danger text-white" value="danger">Danger</option>
                  <option key="7" className="bg-warning text-dark" value="warning">Warning</option>
                  <option key="8" className="bg-info text-white" value="info">Info</option>
                </select>
              </div>
          </div>
          <div className="form-group row">
              <label htmlFor="nav-align-tab" className="col-sm-4 col-form-label font-size-12 align-text-left">
                Varient
              </label>
              <div className="col-sm-8">
                <select
                  value={element.properties.varient}
                  id="nav-align-tab"
                  className="form-control theam-textbox"
                  onChange={(e) => {
                    const newElement = produce(element, draft => { draft.properties.varient = e.target.value})
                    dispatch(startEditElement(newElement));
                  }}
                >
                  <option key="0" value="">--select--</option>
                  <option key="1" value="dark">Dark</option>
                  <option key="2" value="light">Light</option>
                </select>
              </div>
          </div>
          <div className="form-group row">
            <label htmlFor="background-color" className="col-sm-4 col-form-label font-size-12 align-text-left">
              Color
            </label>
            <div className="col-sm-8">
              <div className="row">
                {colorPicker && (
                  <SketchPicker
                    color={element.properties.colour}
                    onChange={(color) => {
                      const newElement = produce(element, draft => { draft.properties.colour = color.hex})
                      dispatch(startEditElement(newElement));
                    }}
                  />
                )}
                <button
                  className="btn btn-block btn-dark btn-theam color-picker-btn-margine"
                  onClick={() => {
                    setColorPicker(!colorPicker);
                  }}
                >
                  <IoColorPalette size={25} />
                </button>
              </div>
            </div>
          </div>
          <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <NavigationTabProperties element={element}/>
    </div>
    );
}

export default NavigationProperties;